import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { fonts, merchantThemes } from 'components/Variable'
import { device } from 'components/Variable'

export const AccordionList = styled.div``
export const Accordion = styled.div`
	position: relative;
`
export const Header = styled.div`
	min-height: ${rem(32)};
	display: flex;
	align-items: center;
	padding: ${rem(5, 0)};
	z-index: 5;
	background-color: ${({ theme }) => theme.color.secondary};
	@media (${device.laptopS}) {
		align-items: flex-start;
	}
`
export const Title = styled.div`
	flex-basis: 0;
	flex-grow: 1;
	max-width: 100%;
	font-size: ${rem(18)};
	line-height: ${rem(20)};
	font-weight: 600;
	font-family: ${fonts.signika};
	cursor: pointer;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
    
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			font-size: ${rem(15)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`
export const AccordionToggle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	transition: all 0.3s;
	margin-right: ${rem(10)};
`
export const Editor = styled.div`
	width: 100%;
	position: relative;
	overflow: hidden;
	padding: ${rem(8, 0)};
	img {
		max-width: 100%;
		margin-bottom: ${rem(16)};
	}
	p {
		font-size: ${rem(14)};
		line-height: ${rem(22)};
		color: ${({ theme }) => theme.color.grayThree};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
				line-height: ${rem(20)};
			`}
	}
`
export const Collapse = styled.div`
	width: 100%;
	position: relative;
	overflow-x: hidden;
	max-height: 0;
	transition: max-height 0.3s;
	padding-left: ${rem(34)};

	${(p) =>
		p.isOpen &&
		css`
			max-height: 500vh;
		`}
`
